import { SettingsViewContent, SettingsViewLayout } from 'modules/settings/settings.style';
import { SettingsDevicesConfigurationStyled } from '../settings-devices-configuration.style';
import { SettingsDevicesConfigurationLayout } from './settings-devices-configuration-layout.component';
import { SettingsDeviceConfigurationLeftMenu } from './settings-devices-configuration-left-menu.component';

export const DeviceConfigurationProperties: React.FC = () => (
    <SettingsViewLayout>
        <SettingsViewContent>
            <SettingsDevicesConfigurationStyled>
                <SettingsDeviceConfigurationLeftMenu />
                <SettingsDevicesConfigurationLayout />
            </SettingsDevicesConfigurationStyled>
        </SettingsViewContent>
    </SettingsViewLayout>
);
